<template>
  <div class="dataCenter">
    <div class="header">
      <div class="header_item" :class="active_tab_list==item.id?'active_header_item':''" v-for="item in tabList" :key="item.id" @click="changItemId(item)">{{ item.name }}</div>
    </div>
    <div class="content">
      <FanAnalysis v-if="active_tab_list==1" />
      <FanPortrait v-if="active_tab_list==2" />
      <FanInterest v-if="active_tab_list==3" />
    </div>

  </div>
</template>
    
    <script>
import FanAnalysis from "../../components/training/FanAnalysis.vue";
import FanPortrait from "../../components/training/FanPortrait.vue";
import FanInterest from "../../components/training/FanInterest.vue";
export default {
  data() {
    return {
      tabList: [
        {
          id: 1,
          name: "粉丝分析",
        },
        {
          id: 2,
          name: "粉丝画像",
        },
        {
          id: 3,
          name: "粉丝兴趣",
        },
      ],
      active_tab_list: 1,
    };
  },
  components: {
    FanAnalysis,
    FanPortrait,
    FanInterest,
  },
  mounted() {},

  methods: {
    changItemId(item) {
      this.active_tab_list = item.id;
    },
  },
};
</script>
    
<style scoped lang="scss">
.dataCenter {
  background: #f5f5f5;
  .header {
    width: 100%;
    position: fixed;
    display: flex;
    background: #f5f5f5;
    padding: 10px;
    top: 92px;
    left: 0;
    z-index: 1500;

    box-sizing: border-box;
    .header_item {
      margin-right: 10px;
      color: #73757b;
      padding: 4px 8px;
      border-radius: 4px;
      cursor: pointer;
    }
    .active_header_item {
      background: #fff;
      color: #333;
    }
  }
  .content {
    padding-top: 40px;
    background: #f5f5f5;
    overflow-y: auto;
    height: 500px;
    // padding-top: 46px;
    box-sizing: border-box;
    scrollbar-width: none;
    -ms-overflow-style: none;
    scrollbar-width: none;
  }
}
</style>
    